<template>
  <div class="signup-page">
    <div class="signup-container">
      <div class="row justify-content-center">
        <!-- Logo -->
        <div class="col-12 text-center mb-4">
          <img
            height="180"
            width="231"
            src="../../../assets/images/LoginLogo.png"
            alt="Logo Png"
          />
          <h5>Registration</h5>
          <p style="font-family: Ebrima">
            Enter Your Details to Register
            <span class="text-success">Wasiyyah</span>
          </p>
        </div>
      </div>

      <!-- Sign-up Form -->
      <form @submit.prevent="onSubmit" @reset.prevent="onReset">
        <div class="row justify-content-center sign-up-wasiyyah">
          <!-- First Name -->
          <div class="col-md-5">
            <b-form-group
              for="first_name"
              label="First Name"
              class="form-label"
            >
              <b-form-input
                type="text"
                v-model="formData.firstName"
                id="first_name"
                class="form-control"
                placeholder="First Name"
                required
              />
            </b-form-group>
          </div>

          <!-- Last Name -->
          <div class="col-md-5">
            <b-form-group for="last_name" label="Last Name" class="form-label">
              <b-form-input
                type="text"
                v-model="formData.lastName"
                id="last_name"
                class="form-control"
                placeholder="Last Name"
                required
              />
            </b-form-group>
          </div>

          <!-- Email -->
          <div class="col-md-5">
            <b-form-group
              for="user_email"
              label="User Email"
              class="form-label"
            >
              <b-form-input
                type="email"
                v-model="formData.email"
                id="user_email"
                class="form-control"
                placeholder="User Email"
                required
              />
            </b-form-group>
          </div>

          <!-- Mobile -->
          <div class="col-md-5">
            <b-form-group for="mobile" label="Mobile No" class="form-label">
              <b-form-input
                type="tel"
                v-model="formData.mobile"
                id="mobile"
                class="form-control"
                placeholder="Mobile No"
                required
              />
            </b-form-group>
          </div>

          <!-- Date of Birth -->
          <div class="col-md-5">
            <b-form-group for="dob" label="Date of Birth" class="form-label">
              <VueDatePicker
                v-model="formData.dob"
                id="dob"
                required
                placeholder="Date of Birth"
              ></VueDatePicker>
            </b-form-group>
          </div>

          <!-- Security Question -->
          <div class="col-md-5">
            <b-form-group
              label-for="security_code"
              label="Security Question"
              class="form-label"
            >
              <select
                class="form-select"
                v-model="formData.securityCode"
                aria-label="Select a Security Question"
              >
                <option
                  v-for="option in securityOption"
                  :key="option.questionId"
                  :value="option.questionId"
                >
                  {{ option.questionText }}
                </option>
              </select>
            </b-form-group>
          </div>

          <!-- Security Answer -->
          <div class="col-md-5" v-if="formData.securityCode">
            <b-form-group
              label="Security Answer"
              for="security_answer"
              class="form-label"
            >
              <b-form-input
                v-model="formData.securityAnswer"
                id="security_answer"
                type="text"
                class="form-control"
                required
              />
            </b-form-group>
          </div>

          <!-- Terms and Conditions -->
          <div class="col-md-5">
            <input
              class="form-check-input me-2"
              type="checkbox"
              id="agree_terms"
              v-model="formData.agreeTerms"
              required
            />
            <label class="form-check-label" for="agree_terms">
              I agree to all statements in
              <a
                href="#"
                @click.prevent="openModalShow"
                class="text-success ms-1"
                >Terms of Service</a
              >
            </label>
          </div>
          <!--<div class="form-check col-md-5">
                        <b-form-group>
                            <b-form-checkbox
                                    class="form-check-input"
                                    type="checkbox"
                                    v-model="formData.agreeTerms"
                                    id="agree_terms"
                                    required> I agree all statements in
                            </b-form-checkbox>
                            <a @click="openModalShow" class="text-success">Terms of Service</a>
                        </b-form-group>
                                            </div>-->
          <div class="col-md-5 d-grid gap-2">
            <button type="submit" class="btn btn-success btn-md">
              Register
            </button>
          </div>
          <!-- Redirect to Login -->
          <div class="col-md-12 text-center">
            <a @click="redirectToLogin"
              >Already have an Account?
              <span class="btn btn-link text-success">Sign In</span></a
            >
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    class="modal fade"
    id="openModal"
    tabindex="-1"
    aria-labelledby="ruleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content p-4">
        <div class="modal-header">
          <h5 class="modal-title" id="ruleModalLabel">Terms of Service</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="text-end mb-3">
            <span class="badge rounded-pill bg-secondary px-3 py-2 fs-6">
              <i class="bi bi-clock-history me-1"></i> Last Updated:
              <strong>May 7, 2025</strong>
            </span>
          </div>
          <div class="mb-4">
            <h5 class="fw-bold text-dark">General Terms</h5>
            <p>
              These Terms govern your use of Wasiyah.com ("Platform"). By
              accessing it, you agree to these Terms and our
              <a href="http://192.168.70.202/privacy-policy" target="_blank"
                >Privacy Policy</a
              >.
            </p>
            <p>
              All registration information you submit will be true, accurate,
              current, and complete.
            </p>
            <p>
              You will not use the Services for any illegal or unauthorized
              purpose.
            </p>
            <p>
              Your use of the Services will not violate any applicable law or
              regulation.
            </p>
            <p>
              You will not create accounts through unauthorized means, including
              but not limited to, by using an automated device, script, bot,
              spider, crawler or scraper.
            </p>
            <p>
              You are solely responsible for your conduct and any data, text,
              files, information, usernames, images, graphics, photos, profiles,
              audio and video clips, sounds, musical works, events, works of
              authorship, applications, links and other content or materials
              (collectively, "Content") that you submit, post or display on or
              via our products.
            </p>
            <p>
              You must not interfere with or disrupt the service or servers or
              networks connected to the Services, including by transmitting any
              viruses, spyware, malware or any other code of a destructive or
              disruptive nature.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Eligibility</h5>
            <p>
              Our services are intended for users who are at least
              <b>18</b> years old. By using Wasiyah.com, you represent and
              warrant that you meet this age requirement and have the legal
              capacity to enter into a binding agreement.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Account Registration</h5>
            <p>
              To access certain features, you may be required to register for an
              account. You agree to:
            </p>
            <ul>
              <li>
                Provide accurate, current, and complete information during the
                registration process.
              </li>
              <li>
                Maintain and promptly update your account information to keep it
                accurate and complete.
              </li>
              <li>
                Maintain the security of your password and accept all risks of
                unauthorized access to your account.
              </li>
              <li>
                Notify us immediately of any unauthorized use of your account.
              </li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Use of the Platform</h5>
            <p>
              You agree to use Wasiyah.com only for lawful purposes and in a way
              that does not infringe the rights of, restrict, or inhibit anyone
              else's use and enjoyment of the platform. Prohibited behavior
              includes:
            </p>
            <ul>
              <li>Engaging in any unlawful or fraudulent activities.</li>
              <li>
                Transmitting any harmful, threatening, defamatory, obscene, or
                otherwise objectionable material.
              </li>
              <li>
                Interfering with the operation of the platform or accessing it
                using automated means.
              </li>
            </ul>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Zakat Calculation</h5>
            <p>
              The Zakat Calculator provided on Wasiyah.com is intended as a
              general guide based on Islamic principles. While we strive for
              accuracy, you are responsible for ensuring the correctness of your
              inputs and understanding that this tool does not constitute
              professional financial advice.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Payments and Donations</h5>
            <p>
              All payments and donations made through Wasiyah.com are processed
              securely via third-party payment providers. You agree to provide
              accurate billing information and authorize us to charge your
              payment method for any transactions made. We are not responsible
              for any errors or issues arising from the payment process.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Intellectual Property</h5>
            <p>
              All content on Wasiyah.com, including text, graphics, logos, and
              software, is the property of Wasiyah.com or its content suppliers
              and is protected by intellectual property laws. You may not
              reproduce, distribute, or create derivative works from any content
              without our express written permission.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Limitation of Liability</h5>
            <p>
              We are not liable for indirect damages or inaccuracies in Zakat
              calculations. Always consult a scholar if in doubt.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Termination</h5>
            <p>
              We reserve the right to suspend or terminate your access to
              Wasiyah.com at our sole discretion, without notice, for conduct
              that we believe violates these terms or is harmful to other users
              of the platform, us, or third parties, or for any other reason.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Governing Law</h5>
            <p>
              These terms and conditions are governed by and construed in
              accordance with the laws of the jurisdiction in which Wasiyah.com
              operates. You agree to submit to the exclusive jurisdiction of the
              courts located within that jurisdiction.
            </p>
          </div>

          <div class="mb-4">
            <h5 class="fw-bold text-dark">Modifications to Terms</h5>
            <p>
              We may revise these terms and conditions at any time without prior
              notice. By continuing to use Wasiyah.com after any changes are
              made, you agree to be bound by the revised terms. It is your
              responsibility to review these terms periodically.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import * as bootstrap from "bootstrap";

export default {
  data() {
    return {
      formData: {
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        dob: "",
        securityCode: null,
        securityAnswer: "",
        source: "Web",
        agreeTerms: false,
      },
      securityOption: [],
      showModal: null,
    };
  },
  mounted() {
    this.getSecurityAnswer();
    this.$nextTick(() => {
      const ruleModalElement = document.getElementById("openModal");
      if (ruleModalElement) {
        this.showModal = new bootstrap.Modal(ruleModalElement); // ✅ assign to showModal (not openModal)
      }
    });
  },
  components: {
    VueDatePicker,
  },
  watch: {
    "formData.dob"(newDate) {
      if (newDate) {
        this.formData.dob = this.formatDate(newDate);
      }
    },
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ("0" + (d.getMonth() + 1)).slice(-2);
      const day = ("0" + d.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },

    onSubmit() {
      if (!this.formData.agreeTerms) {
        toast.error("You must agree to the terms of service");
        return;
      }
      if (!this.formData.firstName || !this.formData.email) {
        toast.error("Name and Email are required");
        return;
      }
      apiRepository
        .callApi(apiRepository.POST_COMMAND, `/user/register`, this.formData)
        .then((res) => {
          if (res.data.code === 200) {
            toast.success(res.data.message);
            this.$router.push({ name: "Login" });
          } else {
            toast.error(
              res.data.message || "Failed to register. Please try again."
            );
          }
        })
        .catch((error) => {
          const errorMessage =
            error.response?.data?.message ||
            error.message ||
            "An error occurred during registration.";
          // toast.error(`Error: ${errorMessage}`);
          console.error(errorMessage);
        });
    },

    getSecurityAnswer() {
      apiRepository
        .callApi(apiRepository.GET_COMMAND, `/user/securityQuestionList`)
        .then((res) => {
          if (res || res.data || res.data.data) {
            this.securityOption = res.data;
          } else {
            toast.error("Network Error!");
          }
        });
    },
    onReset() {
      this.formData = {
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        dob: "",
        securityCode: null,
        securityAnswer: "",
        agreeTerms: false,
      };
    },
    redirectToLogin() {
      this.$router.push({ name: "Login" });
    },
    openModalShow() {
      if (this.showModal) {
        this.showModal.show();
      } else {
        console.error("Modal not initialized");
      }
    },
  },
};
</script>

<style scoped>
.signup-page {
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.signup-page::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("@/assets/images/background.png");
  background-size: cover;
  background-position: center;
  opacity: 0.3; /* Set background opacity to 30% */
  z-index: 1; /* Place behind the content */
}

.signup-container {
  position: relative;
  z-index: 2; /* Place above the background */
  margin-left: 40px;
  /*background-color: rgba(255, 255, 255, 0.8);*/ /* Optional: Semi-transparent background */
  /*padding: 20px;*/
  /*border-radius: 10px;*/
  /*box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);*/
}
</style>
